import { Button, createPolymorphicComponent } from "@mantine/core";
import type { ButtonProps } from "@mantine/core";
import type { IconProps, TablerIcon } from "@tabler/icons-react";
import classNames from "classnames";
import type { ComponentProps } from "react";

interface _IconButtonProps extends Omit<ButtonProps, "leftSection"> {
  icon: TablerIcon;
  iconProps?: IconProps;
}

// Default root element is 'button', but it can be changed with 'component' prop
function _IconButton({ icon, iconProps, ...props }: _IconButtonProps) {
  const Icon = icon;
  const { size, ...otherIconProps } = iconProps || {};
  return (
    <Button
      {...props}
      className={classNames("IconButton", props.className)}
      leftSection={<Icon size={size || "1.4em"} {...otherIconProps} />}
    />
  );
}
_IconButton.displayName = "IconButton";

const IconButton = createPolymorphicComponent<"button", _IconButtonProps>(
  _IconButton
);

type IconButtonProps = ComponentProps<typeof IconButton>;

export { IconButton, IconButtonProps };
